module.exports = __webpack_public_path__ + "img/couponDoctor_c.34fa48d5.png";